"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.number.constructor");require("core-js/modules/es6.number.is-integer");require("core-js/modules/es6.function.name");








































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _Bed = _interopRequireDefault(require("@/components/Bed")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Bed: _Bed.default }, data: function data() {return { tableData: [], // 列表数据
      imageList: [], newadd: false, showBed: false, name: '', bedId: '', patientId: '', searchData: { name: '', patientspace: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', name: '', age: '', complaint: '', hospitalTime: '', mobile: '', sex: '' }, rules: { name: [{ required: true, message: '请输入姓名', trigger: 'blur' }], age: [{ required: true, validator: this.handleCheckAge, trigger: 'blur' }], mobile: [{ required: true, validator: this.handleCheckMobile, trigger: 'blur' }], sex: [{ required: true, message: '请输入性别', trigger: 'blur' }], hospitalTime: [{ required: true, message: '请输入入院时间', trigger: 'blur' }], complaint: [{ required: true, message: '请输入主诉', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'name', label: '姓名', isShow: true }, { prop: 'mobile', label: '电话', isShow: true }, { prop: 'sex', label: '性别', formatter: function formatter(row, column, val) {return val === 1 ? '男' : '女';}, isShow: true }, { prop: 'age', label: '年龄', isShow: true }, { prop: 'hospitalTime', formatter: _formatter.dateSimpleFormatter, label: '入院时间', isShow: true }, { prop: 'complaint', label: '主诉', isShow: true }, { prop: 'ward', label: '床位', formatter: function formatter(row, column, val) {if (row.ward) {return row.ward + ',' + row.bedspace;}}, isShow: true }, { prop: 'doctorName', label: '主治医生', isShow: true }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temi/medical/patient', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.name = '';this.searchData.patientspace = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    addFun: function addFun() {// 新增
      this.name = '新增';
      this.newadd = true;
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();
      this.cleanData();
      this.newadd = false;
      this.newadd2 = false;
    },
    updateMenu: function updateMenu(item) {// 修改操作
      this.name = '修改';
      var self = this;
      self.newadd = true;
      self.addData = {
        id: item.id,
        name: item.name,
        age: item.age,
        complaint: item.complaint,
        hospitalTime: item.hospitalTime,
        mobile: item.mobile,
        sex: item.sex + '' };

    },
    handleLookPatient: function handleLookPatient(item) {
      var self = this;
      self.$refs.bed.handleShow = true;
      self.$refs.bed.id = '';
      self.$refs.bed.init();
      self.patientId = item.id;
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/temi/medical/patient', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    handlePostBed: function handlePostBed(bedId) {// 新增提交操作
      if (bedId) {
        var self = this;
        var postData = {
          'bedId': bedId,
          'id': self.patientId };

        self.postData('/api/temi/medical/patient/bed', postData, function (res) {
          self.$message({
            message: '添加成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/medical/patient?id=' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    unbind: function unbind(delId) {// 删除操作
      var self = this;
      self.$confirm('确定释放该床位吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/medical/patient/bed/' + delId, {}, function (res) {
          self.$message({
            message: '释放成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },

    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        name: '',
        age: '',
        complaint: '',
        hospitalTime: '',
        mobile: '',
        sex: '' };

    },
    handleCheckAge: function handleCheckAge(rule, value, callback) {
      if (!value) {
        return callback(new Error('年龄不能为空'));
      }
      setTimeout(function () {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (value < 1) {
            callback(new Error('必须年满1岁'));
          } else {
            callback();
          }
        }
      }, 500);
    },
    handleCheckMobile: function handleCheckMobile(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      setTimeout(function () {
        var regx = /^[0-9]*$/;
        if (!regx.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      }, 500);
    } } };exports.default = _default;